var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1434 38.6023L80.4543 40.6006L59.1572 42.7336C50.4973 43.6013 43.6638 50.4779 42.8512 59.1435L40.8528 80.4534L38.7199 59.1564C37.8529 50.4965 30.9756 43.663 22.3108 42.8512L1 40.8528L22.2978 38.7199C30.9569 37.8521 37.7905 30.9756 38.6031 22.31L40.6014 1L42.7344 22.297C43.6021 30.9569 50.4787 37.7905 59.1434 38.6023Z",
    fill: "#F69C29"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5962_2401",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 82
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H81.4543V81.4534H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5962_2401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8229 81.3935C40.1897 81.3935 39.6596 80.9134 39.596 80.2834L37.4772 59.1276C36.6765 51.1328 30.2888 44.7854 22.2891 44.0354L1.12014 42.0512C0.487739 41.9916 0.00437398 41.4623 0.00195717 40.8267C0.000345951 40.1919 0.480488 39.6594 1.11289 39.5958L22.2682 37.477C30.263 36.6763 36.6104 30.2895 37.3604 22.2891L39.3455 1.1211C39.4043 0.488707 39.9344 0.00454099 40.5692 0.00292969C40.5708 0.00292969 40.5716 0.00292969 40.5732 0.00292969C41.2064 0.00292969 41.7373 0.482262 41.8001 1.11305L43.9189 22.2681C44.7197 30.2629 51.1073 36.6102 59.107 37.3602L80.276 39.3452C80.9084 39.404 81.3918 39.9341 81.3942 40.5689C81.3958 41.2037 80.9157 41.7363 80.2832 41.7999L59.128 43.9186C51.1331 44.7194 44.7857 51.107 44.0357 59.1066L42.0515 80.2754C41.9919 80.9078 41.4626 81.3911 40.827 81.3935C40.8262 81.3935 40.8245 81.3935 40.8229 81.3935ZM14.0139 40.7824L22.5195 41.58C24.7752 41.7918 26.952 42.3888 28.9894 43.3555C30.972 44.2956 32.7677 45.5588 34.3281 47.1088C35.8878 48.6588 37.1623 50.4472 38.1153 52.4233C39.0941 54.4543 39.7056 56.6278 39.9311 58.8818L40.7827 67.3817L41.5802 58.877C41.7913 56.6213 42.389 54.4438 43.355 52.4064C44.2951 50.4247 45.5583 48.6282 47.1083 47.0677C48.6591 45.5081 50.4467 44.2336 52.4229 43.2814C54.4546 42.3018 56.6274 41.6911 58.8823 41.4648L67.3822 40.6132L58.8766 39.8165C56.6209 39.6046 54.4442 39.0077 52.4068 38.041C50.4242 37.1008 48.6285 35.8376 47.068 34.2877C45.5075 32.7377 44.2339 30.9493 43.2808 28.9731C42.302 26.9414 41.6906 24.7687 41.465 22.5146L40.6135 14.0147L39.8159 22.5195C39.6041 24.7751 39.0071 26.9519 38.0404 28.99C37.1002 30.9718 35.8378 32.7683 34.2878 34.328C32.737 35.8884 30.9494 37.1629 28.9732 38.1151C26.9415 39.0947 24.7688 39.7053 22.5139 39.9317L14.0139 40.7824Z",
    fill: "#0A0A0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b01db798b4e46c1cbb2149b0762167c3.svg";
export { ForwardRef as ReactComponent };